export default __webpack_public_path__ + "static/media/IMG13.6530fa8e.jpg";